import { render, staticRenderFns } from "./NameAndCedula.vue?vue&type=template&id=1775b1a2&scoped=true"
import script from "./NameAndCedula.vue?vue&type=script&lang=ts"
export * from "./NameAndCedula.vue?vue&type=script&lang=ts"
import style0 from "./NameAndCedula.vue?vue&type=style&index=0&id=1775b1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775b1a2",
  null
  
)

export default component.exports